import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'antd';
import RichTextEditor from 'react-rte';
import { useParams } from "react-router";
import { OrganizationContext } from '../../../Services/OrganizationContext';
import authService from '../../../Services/authService';
import { useNavigate } from 'react-router-dom';
import Breadcrumb from "../Breadcrumb/Breadcrumb"
import DatePicker from "react-multi-date-picker";
import "react-multi-date-picker/styles/colors/red.css"; // Optional: Theme
import Trash from "../../Assets/images/recycle-bin.png";
import Plus from "../../Assets/images/plus.png";

const EditOrderwiseFee = () => {

  const navigate = useNavigate();
  const params = useParams();
  const id = params.id.toString();
  const [formData, setFormData] = useState({
    amount:'',
  });
  const { organization } = useContext(OrganizationContext);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [areas, setAreas] = useState([]);
  const [file, setFile] = useState(null);
  const [editorState, setEditorState] = useState(RichTextEditor.createEmptyValue());
  const [selectedDates, setSelectedDates] = useState([]);
  const [fromTime, setFromTime] = useState("");
  const [toTime, setToTime] = useState("");
  const [duration, setDuration] = useState("");
  const [timeSlots, setTimeSlots] = useState([]);
  const [offerDetails, setOfferDetails] = useState([{ id: Date.now(), detail: '' }]);

  // errors
  const [errors, setErrors] = useState({});

    useEffect(() => {
      if (organization) {
        loadData();
      }
    }, [organization]);

    const loadData = () => {
      const token = authService.getCurrentadmin().token;
      const url = new URL(authService.getApiUrl() + 'orderwisefee/' + id);
    
      fetch(url, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json; charset=UTF-8',
          Authorization: `Bearer ${token}`,
        },
      })
        .then((res) => {
          if (res.status === 401) {
            authService.logout();
            window.location.href = "/admin";
          } else {
            return res.json();
          }
        })
        .then((result) => {
          const data = result.data;
          //setFormData(result.data);
          setFormData({
            ...data,
           // Is_Active: data.Is_Active === "A",  // Convert "A" to true and "I" to false
          });
          
        })
        .catch((err) => {
          console.log(err.message);
        });
    };


  const validateForm = () => {
    let errors = {};
    if (!formData.amount) errors.amount = "Per Order Amount is required";
  

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handlesubmit = (event) => {
    event.preventDefault(); // Prevent default form submission
    if (!validateForm()) return;
    const token = authService.getCurrentadmin().token;


    fetch(authService.getApiUrl() + 'orderwisefee/'+id, {
      method: 'PUT',
      body: JSON.stringify({
        amount: formData.amount,
      }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        navigate(`/admin/orderwise-fee`);
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    setFormData({
      ...formData,
      //[name]: type === 'checkbox' ? checked : value,
      [name]: name === "coupon_code" ? value.toUpperCase() : (type === 'checkbox' ? checked : value),
    });
  };


  return (
    <div className='main-container'>
      <div className='container-fluid'>
        <Breadcrumb />
        <div className='category-table'>
          <div className='flex-cont add-cat'>
            <div className='heading'>
              <h3>Edit Orderwise Fee</h3>
            </div>
          </div>
          <div className="card">
            <div className="card-body custom-edit-service">
              <form className="needs-validation clearfix" onSubmit={handlesubmit} >
                <div className="addtest-fields mb-3">
                  <div className="flex-cont">

                    <div className="full-cont">
                      <div className="form-group">
                        <label>
                          Per Order Amount
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          name="amount"
                          id="amount"
                          // required
                          value={formData.amount}
                          onChange={handleInputChange}
                        />
                        {errors.amount && <span className='errors' >{errors.amount}</span>}
                      </div>
                    </div>
   

                  </div>
                </div>

                <div className="submit-section">

                  <button
                    className="btn btn-primary submit-btn"
                    type="submit"
                    name="form_submit"

                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditOrderwiseFee;
